<!--
  Generated template for the EventSearchMapPage page.

  See http://ionicframework.com/docs/components/#navigation for more info on
  Ionic pages and navigation.
-->

<ion-header>

  <ion-toolbar>
    <ion-title>
      {{'GLOBAL_SEARCH_RESULTS' | translate}}
    </ion-title>
  </ion-toolbar>

</ion-header>
<ion-content>
  <google-maps (mapLoaded)="mapLoaded($event)"></google-maps>
</ion-content>